import * as React from "react";
import { SVGProps } from "react";

export const IconMicrosoftMeeting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={0.2}
      y={0.2}
      width={16.6}
      height={16.1}
      rx={2.8}
      fill="#1976D2"
      stroke="#1976D2"
      strokeWidth={0.4}
    />
    <path
      d="M3.23 12.015L8.843 13V4l-5.613.985v7.03zM9.244 11.509a1.222 1.222 0 001.99-.951V7.619h-1.99v3.89zM10.011 7.162a.971.971 0 10-.767-1.566v1.19a.969.969 0 00.768.376zM13.75 8.249h-2.11v2.596a1.206 1.206 0 001.781.067c.227-.229.353-.54.35-.863l-.02-1.8zM12.542 7.797a.96.96 0 100-1.921.96.96 0 000 1.92z"
      fill="#fff"
    />
    <path
      d="M7.143 7.494h-.838V9.94H5.8V7.494h-.837v-.503h2.18v.503z"
      fill="#1976D2"
    />
  </svg>
);
